var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.scene,{ref:"component_ref",tag:"component",attrs:{"page-config":_vm.page_config}})
}
var staticRenderFns = []

export { render, staticRenderFns }